module.exports = __webpack_public_path__ + "img/task_desc.1e2991d7.png";